"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CacheElement = (function () {
    function CacheElement(id, value) {
        this._key = id;
        this._value = value;
    }
    Object.defineProperty(CacheElement.prototype, "key", {
        get: function () {
            return this._key;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CacheElement.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    return CacheElement;
}());
var Cache = (function () {
    function Cache(maxItems) {
        this._cache = new Array();
        this._maxItems = maxItems;
    }
    Cache.prototype.get = function (id) {
        var result = _.find(this._cache, "key", id);
        if (result !== undefined) {
            return result.value;
        }
        else {
            return undefined;
        }
    };
    Cache.prototype.set = function (id, element) {
        if (this.get(id) === undefined) {
            var newCacheElement = new CacheElement(id, element);
            this._cache.push(newCacheElement);
            this._cache = _.sortBy(this._cache, "key");
            if (this._maxItems !== undefined && this._cache.length > this._maxItems) {
                this.removeOldestEntry();
            }
            return true;
        }
        else {
            return false;
        }
    };
    Cache.prototype.count = function () {
        return this._cache.length;
    };
    Cache.prototype.removeOldestEntry = function () {
        var cacheSortedByDate = _.sortBy(this._cache, "_lastAccess");
        var oldestItem = cacheSortedByDate[0];
        this._cache = _.without(this._cache, oldestItem);
    };
    Cache.prototype.clear = function () {
        this._cache = new Array();
    };
    return Cache;
}());
exports.Cache = Cache;
//# sourceMappingURL=cache.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/cache.js
// module id = 10
// module chunks = 0